// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}
:host ::ng-deep .statement-of-work {
  font-family: 'Source Sans Pro', 'Segoe UI', 'Droid Sans', Tahoma, Arial, sans-serif;
  font-size: 14px;
  margin: 0 0 10px 0;
}
:host ::ng-deep .statement-of-work h1, 
:host ::ng-deep .statement-of-work h2 {
  font-size: 38px;
  font-weight: 300;
}
:host ::ng-deep .statement-of-work h2 {
  font-size: 33px;
}
:host ::ng-deep .left-nav h4 {
  font-size: 16px;
  font-weight: 700;
  color: #303E4E;
  text-transform: uppercase;
  margin-bottom: 10px;
}
:host ::ng-deep .left-nav ul {
  list-style: decimal;
  list-style-position: inside;
}
:host ::ng-deep .left-nav ul li {
  color: #3597EC;
  font-weight: 600;
}
:host ::ng-deep .left-nav ul li a {
  font-size: 15px;
  text-transform: uppercase;
  color: #3597EC;
  line-height: 36px;
}
:host ::ng-deep .left-nav ul li a.active {
  text-decoration: underline;
  text-transform: capitalize;
}
:host ::ng-deep .statement-of-work .kb-logo {
  max-width: 280px;
}
:host ::ng-deep .statement-of-work .kb-logo img {
  max-width: 100%;
}
:host ::ng-deep .main-heading h1 {
  font-size: 32px;
  font-weight: 700;
  line-height: 32px;
  margin-bottom: 20px;
  color: #303E4E;
}
:host ::ng-deep .main-heading h2 {
  color: #303E4E;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 15px;
  text-transform: uppercase;
}
:host ::ng-deep .section-link h3 {
  font-size: 18px;
  font-weight: 700;
  line-height: 18px;
  margin-bottom: 7px;
  color: #303E4E;
  text-transform: uppercase;
}
:host ::ng-deep .statement-of-work .intro p {
  font-size: 16px;
  line-height: 22px;
}
:host ::ng-deep .section-link {
  padding-bottom: 20px;
  margin-bottom: 30px;
  border-bottom: #eaeaea solid 1px;
}
:host ::ng-deep .section-link p {
  font-size: 14px;
  margin-bottom: 14px;
  line-height: 22px;
}
:host ::ng-deep .list-box ul {
  list-style: circle;
  margin: 10px 10px 10px 15px;
  list-style: disc;
}
:host ::ng-deep .list-box ul li {
  line-height: 21px;
  margin-bottom: 5px;
}
:host ::ng-deep .bottom-section {
  background: #F5F6FA;
  padding: 20px;
}
:host ::ng-deep .bottom-section h4 {
  font-size: 16px;
  font-weight: 700;
  color: #303E4E;
  margin-bottom: 10px;
}
:host ::ng-deep .bottom-section p {
  font-size: 14px;
}
:host ::ng-deep .theme-bg {
  background: #303E4E;
}
:host ::ng-deep .white-color {
  color: #fff;
}
:host ::ng-deep ul {
  list-style: circle;
  margin: 10px 10px 10px 15px;
  list-style: disc;
  padding-left: 40px;
}
:host ::ng-deep ul li {
  line-height: 21px;
  margin-bottom: 5px;
}
.ul-Name {
  padding: 0px;
  margin: 0px 0px 0px 0px;
}
.table-header {
  background-color: #f5f6fa;
  font-weight: 700;
  text-align: center;
  font-size: 18px;
  padding: 10px;
}
.list-decimal {
  list-style-type: decimal;
  margin-left: 20px;
}

.list-decimal ol {
  list-style-type: lower-alpha;
  margin-left: 20px;
}

.list-circle {
  list-style-type: circle;
  margin-left: 20px;
}

/* Custom class to handle numbering */
.custom-decimal {
  counter-reset: item;
  list-style: none;
  padding-left: 0;
}

.custom-decimal > li {
  counter-increment: item;
  position: relative;
}

.custom-decimal > li::before {
  content: counter(item) ". ";
  position: absolute;
  left: -30px; /* Adjust based on your layout */
}

/* For nested lists */
.custom-decimal .nested-list {
  counter-reset: sub-item;
  list-style: none;
  padding-left: 20px; /* Adjust for indentation */
}

.custom-decimal .nested-list > li {
  counter-increment: sub-item;
  position: relative;
}

.custom-decimal .nested-list > li::before {
  content: counter(item) "." counter(sub-item) " ";
  position: absolute;
  left: -30px; /* Adjust based on your layout */
}

ol[type="i"] {
  list-style-type: lower-roman;
}`, "",{"version":3,"sources":["webpack://./src/app/components/terms-and-conditions/terms-and-conditions.component.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,mFAAmF;EACnF,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW,EAAE,gCAAgC;AAC/C;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB,EAAE,2BAA2B;AACjD;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,WAAW,EAAE,gCAAgC;AAC/C;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["html {\n  scroll-behavior: smooth;\n}\n:host ::ng-deep .statement-of-work {\n  font-family: 'Source Sans Pro', 'Segoe UI', 'Droid Sans', Tahoma, Arial, sans-serif;\n  font-size: 14px;\n  margin: 0 0 10px 0;\n}\n:host ::ng-deep .statement-of-work h1, \n:host ::ng-deep .statement-of-work h2 {\n  font-size: 38px;\n  font-weight: 300;\n}\n:host ::ng-deep .statement-of-work h2 {\n  font-size: 33px;\n}\n:host ::ng-deep .left-nav h4 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #303E4E;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n}\n:host ::ng-deep .left-nav ul {\n  list-style: decimal;\n  list-style-position: inside;\n}\n:host ::ng-deep .left-nav ul li {\n  color: #3597EC;\n  font-weight: 600;\n}\n:host ::ng-deep .left-nav ul li a {\n  font-size: 15px;\n  text-transform: uppercase;\n  color: #3597EC;\n  line-height: 36px;\n}\n:host ::ng-deep .left-nav ul li a.active {\n  text-decoration: underline;\n  text-transform: capitalize;\n}\n:host ::ng-deep .statement-of-work .kb-logo {\n  max-width: 280px;\n}\n:host ::ng-deep .statement-of-work .kb-logo img {\n  max-width: 100%;\n}\n:host ::ng-deep .main-heading h1 {\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 32px;\n  margin-bottom: 20px;\n  color: #303E4E;\n}\n:host ::ng-deep .main-heading h2 {\n  color: #303E4E;\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 15px;\n  text-transform: uppercase;\n}\n:host ::ng-deep .section-link h3 {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 18px;\n  margin-bottom: 7px;\n  color: #303E4E;\n  text-transform: uppercase;\n}\n:host ::ng-deep .statement-of-work .intro p {\n  font-size: 16px;\n  line-height: 22px;\n}\n:host ::ng-deep .section-link {\n  padding-bottom: 20px;\n  margin-bottom: 30px;\n  border-bottom: #eaeaea solid 1px;\n}\n:host ::ng-deep .section-link p {\n  font-size: 14px;\n  margin-bottom: 14px;\n  line-height: 22px;\n}\n:host ::ng-deep .list-box ul {\n  list-style: circle;\n  margin: 10px 10px 10px 15px;\n  list-style: disc;\n}\n:host ::ng-deep .list-box ul li {\n  line-height: 21px;\n  margin-bottom: 5px;\n}\n:host ::ng-deep .bottom-section {\n  background: #F5F6FA;\n  padding: 20px;\n}\n:host ::ng-deep .bottom-section h4 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #303E4E;\n  margin-bottom: 10px;\n}\n:host ::ng-deep .bottom-section p {\n  font-size: 14px;\n}\n:host ::ng-deep .theme-bg {\n  background: #303E4E;\n}\n:host ::ng-deep .white-color {\n  color: #fff;\n}\n:host ::ng-deep ul {\n  list-style: circle;\n  margin: 10px 10px 10px 15px;\n  list-style: disc;\n  padding-left: 40px;\n}\n:host ::ng-deep ul li {\n  line-height: 21px;\n  margin-bottom: 5px;\n}\n.ul-Name {\n  padding: 0px;\n  margin: 0px 0px 0px 0px;\n}\n.table-header {\n  background-color: #f5f6fa;\n  font-weight: 700;\n  text-align: center;\n  font-size: 18px;\n  padding: 10px;\n}\n.list-decimal {\n  list-style-type: decimal;\n  margin-left: 20px;\n}\n\n.list-decimal ol {\n  list-style-type: lower-alpha;\n  margin-left: 20px;\n}\n\n.list-circle {\n  list-style-type: circle;\n  margin-left: 20px;\n}\n\n/* Custom class to handle numbering */\n.custom-decimal {\n  counter-reset: item;\n  list-style: none;\n  padding-left: 0;\n}\n\n.custom-decimal > li {\n  counter-increment: item;\n  position: relative;\n}\n\n.custom-decimal > li::before {\n  content: counter(item) \". \";\n  position: absolute;\n  left: -30px; /* Adjust based on your layout */\n}\n\n/* For nested lists */\n.custom-decimal .nested-list {\n  counter-reset: sub-item;\n  list-style: none;\n  padding-left: 20px; /* Adjust for indentation */\n}\n\n.custom-decimal .nested-list > li {\n  counter-increment: sub-item;\n  position: relative;\n}\n\n.custom-decimal .nested-list > li::before {\n  content: counter(item) \".\" counter(sub-item) \" \";\n  position: absolute;\n  left: -30px; /* Adjust based on your layout */\n}\n\nol[type=\"i\"] {\n  list-style-type: lower-roman;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
